import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' },
});

const TOKEN_KEY = 'vx_access_token';
const MFA_KEY = 'vx_mfa_token';

export const saveAuthTokens = (data) => {
  if (data?.access_token) { localStorage.setItem(TOKEN_KEY, data.access_token); localStorage.removeItem(MFA_KEY); }
  if (data?.mfa_token) localStorage.setItem(MFA_KEY, data.mfa_token);
};

export const clearAuthTokens = () => { localStorage.removeItem(TOKEN_KEY); localStorage.removeItem(MFA_KEY); };

api.interceptors.request.use((config) => {
  const t = localStorage.getItem(TOKEN_KEY);
  const m = localStorage.getItem(MFA_KEY);
  if (t) config.headers.Authorization = `Bearer ${t}`;
  if (m) config.headers['X-MFA-Token'] = m;
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return 'Something went wrong. Please try again.';
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === 'string' ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(' ');
  if (detail && typeof detail.msg === 'string') return detail.msg;
  return String(detail);
}

export const errMsg = (e) => formatApiErrorDetail(e?.response?.data?.detail) || e?.message;

export const fmtUsd = (v, max = 2) => {
  const n = Number(v);
  if (!isFinite(n)) return '—';
  return n.toLocaleString(undefined, { style: 'currency', currency: 'USD', maximumFractionDigits: max });
};

export const fmtNum = (v, max = 2) => {
  const n = Number(v);
  if (!isFinite(n)) return '—';
  return n.toLocaleString(undefined, { maximumFractionDigits: max });
};

export const fmtDate = (v) => {
  if (!v) return '—';
  try { return new Date(v).toLocaleString(); } catch { return v; }
};

export const shortHash = (h) => (h ? `${h.slice(0, 8)}…${h.slice(-6)}` : '—');
